<template>
    <div class="c-clients-say">
        <div class="c-clients-say__content">
            <div class="c-clients-say__content__cover-box">
                <img
                    v-if="!headerImg"
                    :src="content?.image?.link"
                    :alt="content?.text"
                >
                <img
                    v-if="headerImg"
                    :src="content?.header_image?.link"
                    :alt="content?.text"
                >
            </div>
            <div class="c-clients-say__content__slider-box ">
                <div class="c-clients-say__content__slider-box__title">
                    <component
                        :is="titleTag || 'h2'"
                        v-if="!differentTitle"
                        class="title"
                    >
                        {{ content?.title }}
                    </component>
                    <component
                        :is="titleTag || 'h2'"
                        v-if="differentTitle"
                        class="title"
                    >
                        {{ content?.custom.field3 }}
                    </component>
                </div>

                <div
                    v-if="clientsSay && clientsSay.length"
                    class="c-clients-say__content__slider-box__slider"
                    :class="$i18n.locale !== 'ar' ? 'justify-dot-end' : 'justify-dot-start'"
                >
                    <y-owl-slide-show
                        ref="owlSlideShow"
                        :items="1"
                        :margin="7"
                        dots
                        loop
                        auto-height
                        @indexItem="changeSliderHandler($event)"
                    >
                        <div
                            v-for="(item, index) in clientsSay"
                            :key="`clients-say-${index}`"
                            class="pa-3 pt-6 pb-6"
                            :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
                        >
                            <div class="svg-box">
                                <img
                                    src="@/assets/images/right-quote.svg"
                                    :alt="item.id"
                                >
                            </div>
                            <div class="slider-card">
                                <p>
                                    {{ item.synopsis }}
                                </p>
                                <y-row>
                                    <y-col
                                        md="12"
                                        lg="9"
                                    >
                                        <div class="d-f pt-5">
                                            <img
                                                :src="item.image.versions.main1 || item.image.link"
                                                alt="profile"
                                                class="slider-profile"
                                            >
                                            <div class="clients-details">
                                                <div>
                                                    <b>{{ item.title + ' ,' }}</b>
                                                </div>
                                                <div>
                                                    <span>{{ ' ' + item.title2 }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </y-col>
                                    <y-col
                                        md="12"
                                        lg="3"
                                        class="d-f align-items-center"
                                    >
                                        <img
                                            :src="item.header_image.versions.main1 || item.header_image.link"
                                            class="slider-brand"
                                            alt=""
                                        >
                                    </y-col>
                                </y-row>
                            </div>
                        </div>
                    </y-owl-slide-show>
                    <div class="c-clients-say__content__slider-box__slider__counter-box">
                        <div
                            v-for="index in clientsSay.length"
                            :key="index"
                            class="show-desktop"
                        >
                            <p
                                :class="slideIsShowing === index ? 'active' : ''"
                                @click="specificSlide(index)"
                            >
                                {{ digits(index < 10 ? `0${index}` : index, $i18n.locale) }}
                            </p>

                            <div
                                v-if="slideIsShowing === index"
                                class="border-showing"
                            />
                        </div>
                        <div class="show-mobile">
                            <p class="active">
                                {{ digits(slideIsShowing < 10 ? `0${slideIsShowing}` : slideIsShowing, $i18n.locale) }}
                            </p>
                            <div class="border-showing" />
                        </div>
                    </div>
                    <div
                        class="c-clients-say__content__slider-box__slider__navs"
                        :style="`gap: ${ clientsSay.length * 25 }px`"
                    >
                        <y-button
                            color="white"
                            :icon-append="$i18n.locale === 'ar' ? 'fa-caret-right' : 'fa-caret-left'"
                            @click="$refs.owlSlideShow[$i18n.locale === 'ar' ? 'nextItem' : 'prevItem']()"
                        />

                        <y-button
                            color="white"
                            :icon-append="$i18n.locale === 'ar' ? 'fa-caret-left' : 'fa-caret-right'"
                            @click="$refs.owlSlideShow[$i18n.locale === 'ar' ? 'prevItem' : 'nextItem']()"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import YOwlSlideShow from '@components/OwlSlideShow/Index';
    import { digits } from '@groot-nodes/helpers/number';

    export default {
        name      : 'OurClientsSay',
        components: { YOwlSlideShow },
        props     : {
            content       : Object,
            clientsSay    : Array,
            titleTag      : String,
            headerImg     : Boolean,
            differentTitle: Boolean,
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                slideIsShowing: 1,
            };
        },

        methods: {
            digits,
            /**
             * change slider event listener
             *
             * @param {number} index
             */
            changeSliderHandler(index) {
                this.slideIsShowing = index;
            },
            /**
             * Go to specific slide
             *
             * @param {*} index
             */
            specificSlide(index) {
                this.$refs.owlSlideShow.specificSlide(index);
            },

        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
